<template>
  <div class="my-pooq-content-body" >
    <div class="wrap">
      <my-pooq-type :data="dataMypooqType" :device="device" :is-loading="isLoading"/>
      <my-pooq-graph v-if="dataMypooqType && dataMypooqType.type" :device="device"/>
      <analysis-program-list v-if="dataMypooqType && dataMypooqType.type && dataProgramList" :data-list="dataProgramList" :device="device"/>
      <analysis-vod-person-list v-if="dataMypooqType && dataMypooqType.type && dataPersonList" :data-list="dataPersonList" :device="device"/>
      <analysis-channel-list v-if="dataMypooqType && dataMypooqType.type && dataChannelList" :data-list="dataChannelList" :device="device"/>
      <use-device v-if="dataMypooqType && dataMypooqType.type && dataDeviceList" :data-list="dataDeviceList"/>
    </div>
  </div>
</template>

<script>
import MyPooqType from '@/components/lnb/mypooq/MyPooqType'
import MyPooqGraph from '@/components/lnb/mypooq/MyPooqGraph'
import AnalysisProgramList from '@/components/lnb/mypooq/AnalysisProgramList'
import AnalysisVodPersonList from '@/components/lnb/mypooq/AnalysisVodPersonList'
import AnalysisChannelList from '@/components/lnb/mypooq/AnalysisChannelList'
import UseDevice from '@/components/lnb/mypooq/UseDevice'
import { MyPooqService } from '@/common/api/api.service'
import utils from '@/common/util/utils'

export default {
  name: 'MyPooqTasteAnalysis',
  components: {
    MyPooqType,
    MyPooqGraph,
    AnalysisProgramList,
    AnalysisVodPersonList,
    AnalysisChannelList,
    UseDevice
  },
  data () {
    return {
      isNoData: false,
      dataMypooqType: undefined,
      dataProgramList: undefined,
      dataPersonList: undefined,
      dataChannelList: undefined,
      dataTagList: undefined,
      dataDeviceList: undefined,
      device: utils.cookies.getDevice(),
      isLoading: false
    }
  },
  created () {
    if (this.isLoading) return
    this.isLoading = true
    MyPooqService.analysisIntro().then(({ data }) => {
      this.dataMypooqType = data
      this.isLoading = false
    })

    MyPooqService.analysisLists().then((response) => {
      response.data.forEach(data => {
        switch (data.type) {
          case 'analysisprogramlist':
            this.dataProgramList = data.list
            break
          case 'analysisvodpersonlist':
            this.dataPersonList = data.list
            break
          case 'analysischannellist':
            this.dataChannelList = data.list
            break
          case 'analysistaglist':
            this.dataTagList = data.list
            break
          case 'analysisdevicelist':
            this.dataDeviceList = data.list
            break
          default:
            break
        }
      })
    })
  }
}
</script>

<!--<style lang="css" src="@/assets/css/common.css"></style>-->
<!--<style lang="css" src="@/assets/css/base.css"></style>-->
<!--<style lang="css" src="@/assets/css/swiper.css"></style>-->
<style lang="css">
  .wrap{
    overflow: hidden;
  }

  .mypooq-chart-circle{
    margin-top: 10px;
  }
  .my-pooq-noti{
    padding: 20px 0 40px;
    text-align: center;
  }

  .my-pooq-noti p{
    font-size: 14px;
    line-height: 20px;
    color: #a5a5a5;
  }

  .my-pooq-noti p span{
    color: #fff;
  }

  .my-pooq-noti-btn{
    padding: 0 20px;
  }

  .my-pooq-noti-btn li{
    margin-bottom: 10px;
    background: url(/public/img/mypooq/arrow-title-purple.png) no-repeat 95% center;
    background-size: 12px;
  }

  .my-pooq-noti-btn li a{
    display: flex;
    height: 80px;
    line-height: 80px;
    border-radius: 6px;
    border: solid 1px #a5a5a5;
    padding: 0 17px;
    color: #fff;
  }

  .my-pooq-noti-btn img{
    width: 41px;
    margin-right: 16px;
  }

  .my-pooq-noti-btn li a span{
    font-size: 16px;
  }

  /*리스트 없음*/
  .my-list-empty{
    padding: 40px 0;
    text-align: center;
    /*padding: 59px 0;*/
  }

  /*.my-graph-wrap .my-list-empty{*/
  /*  border-top: 1px #2f2f2f solid;*/
  /*  border-bottom: 1px #2f2f2f solid;*/
  /*}*/

  .my-list-empty > span{
    display: block;
    margin-bottom: 9px;
    font-size: 0;
  }

  .my-list-empty > img{
    margin-bottom: 14px;
  }

  .my-list-empty p{
    font-size: 14px;
    line-height: 16px;
    color: #a5a5a5;
  }

  .my-empty-btn{
    display: inline-block;
    margin: 15px auto 0;
    font-size: 13px;
    line-height: 18px;
    color: #a5a5a5;
  }

  .my-empty-btn span,
  .my-empty-btn svg{
    display: inline-block;
    vertical-align: middle;
  }

  .my-empty-btn span{
    color: #fff;
  }

  .my-empty-btn span + svg,
  .my-empty-btn svg + span{
    margin-left: 5px;
  }

  .my-empty-btn img{
    width: 19px;
    margin-left: 5px;
  }
</style>
